export const isNotDuplicateEmail = (settings) => (value) => {
    const allEmails = settings.notificationSettings.map((item) => item.email);
    return !allEmails.includes(value);
};
